<template>
  <div class="relative">
    <vue-recaptcha class="mt-6" :sitekey="RECAPTCHA_SITE_KEY"
                   @verify="validateCaptcha"
                   :loadRecaptchaScript="true"></vue-recaptcha>
    <div v-if="formDisabled" class="absolute inset-0 bg-gray-200 rounded"></div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "RecaptchaField",
  data() {
    return {
      // TODO: Load Site Key from Env
      RECAPTCHA_SITE_KEY: "6LdBQeMUAAAAACEiFShp2CgMKG-GFU47VHGlk8x4"
    };
  },
  components: {
    VueRecaptcha
  },
  props: ["value", "field", "id", "hasError"],
  computed: {
    formDisabled() {
      return this.$store.state.formDisabled;
    },
  },
  methods: {
    validateCaptcha(response) {
      this.$emit("input", response);
    }
  }
};
</script>

<style scoped>

</style>
